<template>
  <div :style="'height:'+height+'px;width:'+width+'px;'">
    <div class="left" :style="'height:'+height+'px;width:445px;overflow:auto;float: left'">
      <div
        class="menu_top"
        :style="'height:'+(side2_menu_height - (project_update_count > 0?0:20))+'px;'"
      >
        <div style="text-align: left;">
          <span class="category_btn typeSelected" @click="add_project">新建项目</span>
        </div>

        <div v-if="init_list">
          <el-input v-model="search_word" placeholder="请输入项目名称或关键字"></el-input>
          <span
            class="category_btn selected_btn"
            :class="{'search_selected':!is_leader&&!is_update && projectsItemShow.length == projectsList.list.length}"
            @click="selecteProjectList('total')"
          >显示全部</span>
          <span
            class="category_btn selected_btn"
            :class="{'search_selected':is_leader}"
            @click="selecteProjectList('is_leader')"
          >我负责的</span>
        </div>
        <div style="font-size: 12px; line-height: 20px;word-spacing: 3px;">
          <!--<img src="../assets/add_file.png" style="width: 20px;height: auto;vertical-align: middle;">-->
          <span
            :style="{borderBottom:(is_update?'1px solid red':'none')}"
            class="updateTxt"
            @click="get_update_list"
            v-if="project_update_count > 0"
          >有{{project_update_count}}个项目更新，点击查看</span>
          <div style="color:#6fa1d4; ">共{{projectsItemShow.length}}个项目</div>
        </div>
      </div>
      <div
        :style="'height:'+ (height - side2_menu_height + (project_update_count > 0?0:20)) +'px;overflow: auto'"
      >
        <el-menu v-if="done">
          <el-submenu index="1" :key="index+''" v-for="(item,index) in projectsItemShow">
            <template slot="title">
              <div
                @click="show_project_detail(item.id,index)"
                :class="{'project_selected':project_id==item.id}"
                class="project_item"
              >
                <div
                  class="project_name"
                  :title="item.is_name_more?item.project_num+'' + item.name:'' "
                >{{index+1}}.{{item.project_num}}&nbsp;&nbsp;{{item.name}}</div>
                <!-- <div class="warpper_update" v-if="item.has_update"><span class="icon_update">有更新</span></div> -->
                <div
                  style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                  :title="util.str_gb_len(item.objective) > 428?item.objective:'' "
                >{{item.objective}}</div>
                {{item.project_type != ''?item.project_type:''}} - {{item.create_user}} / {{typeof(item.create_time) == "string" ? item.create_time.slice(0,10) : item.create_time}}
                <span
                  class="icon_update fr"
                  v-if="item.has_update"
                >有更新</span>
              </div>

              <div
                class="detail_wrapper"
                v-if="project_id==item.id"
                :class="{'content_show':project_id==item.id}"
              >
                <div class="project_detail">
                  <div>
                    项目描述:
                    <div
                      class="desc_detail"
                      :id="'id'+item.id"
                      @click="more_desc(item.project_num,item.name)"
                    >
                      <div style="line-height: normal;">
                        <div
                          v-html="project_dataInit.description"
                          :style="{color:(desc_update?'#ff0000':'initial')}"
                        ></div>
                      </div>
                      <div class="ellipsis" v-if="project_dataInit.description_high > 130">....</div>
                    </div>
                  </div>
                  <div class="detail">
                    项目预计
                    <span
                      :style="{color:(end_time_update?'#ff0000':'initial')}"
                    >{{typeof(project_dataInit.end_time) == "string" ? project_dataInit.end_time.slice(0,10) : project_dataInit.end_time}}</span>完成!
                  </div>
                </div>
                <div style="background-color: #fff; " class="other_detail">
                  <div
                    class="detail"
                    :title="util.str_gb_len('项目人员: '+project_usernames) > 409 ?project_usernames:'' "
                  >
                    项目人员:
                    <span v-if="manage_user_ids.length > 0">
                      <span
                        v-for="(item,key) in manage_user_ids"
                        :key="key"
                        :style="{color:(project_user_update.indexOf(item.user_id) > -1?'#ff0000':'#303133')}"
                      >
                        <span v-if="key > 0">、{{item.username}}</span>
                        <span v-else>{{item.username}}</span>
                      </span>
                      <span v-if="leader_user_ids.length > 0 || join_user_ids.length > 0">;</span>
                    </span>
                    <span v-if="leader_user_ids.length > 0">
                      <span
                        v-for="(item,key) in leader_user_ids"
                        :key="key"
                        :style="{color:(project_user_update.indexOf(item.user_id) > -1?'#ff0000':'#303133')}"
                      >
                        <span v-if="key > 0">、{{item.username}}</span>
                        <span v-else>{{item.username}}</span>
                      </span>
                      <span v-if="join_user_ids.length > 0">;</span>
                    </span>
                    <span v-if="join_user_ids.length > 0">
                      <span
                        v-for="(item,key) in join_user_ids"
                        :key="key"
                        :style="{color:(project_user_update.indexOf(item.user_id) > -1?'#ff0000':'#303133')}"
                      >
                        <span v-if="key > 0">、{{item.username}}</span>
                        <span v-else>{{item.username}}</span>
                      </span>
                    </span>
                  </div>
                  <div
                    class="detail"
                    v-if="project_dataInit.customer_ids.length > 0"
                    :title="util.str_gb_len('客户: '+customer_ids_str) > 409 ?customer_ids_str:'' "
                  >
                    <span>客户:</span>
                    <span v-for="(item,key) in project_dataInit.customer_ids" :key="key">
                      <span
                        v-if="key > 0"
                      >、{{item.khjc == '' || item.khjc == null ? item.khmc:item.khjc }}</span>
                      <span v-else>{{item.khjc == '' || item.khjc == null ? item.khmc:item.khjc }}</span>
                    </span>
                  </div>
                  <div
                    class="detail"
                    :title="util.str_gb_len('关键字: '+project_dataInit.keyword) > 409 ?project_dataInit.keyword:'' "
                  >
                    关键字:
                    {{project_dataInit.keyword}}
                  </div>
                  <div
                    style="text-align: right;"
                    v-if="leader_user_ids_array.indexOf(user_info.user_id) > -1 &&  project_dataInit.status.indexOf('进行中') > -1"
                  >
                    <span
                      class="category_btn typeSelected"
                      @click="change_project_status(item.id,2)"
                    >完成</span>
                    <span
                      class="category_btn typeSelected"
                      @click="change_project_status(item.id,3)"
                    >终止</span>
                    <span class="category_btn typeSelected" @click="show_project_edit(item.id)">修改</span>
                  </div>
                </div>
              </div>
            </template>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <div :style="'height:'+height+'px;width:'+(width - 450) +'px;float: left'">
      <router-view
        v-if="is_router_alive"
        :height="height"
        :width="width - 450"
        :web_token="web_token"
        :user_info="user_info"
        :web_url="web_url"
        :before_visit_time="before_visit_time"
        :templates="templates"
        :project_detail="project_detail"
        :add_project_success="add_project_success"
      ></router-view>
    </div>

    <!--查看项目描述-->
    <el-dialog :visible.sync="descriptionVisible">
      <div style="color: #0b509d;font-size: 16px;">
        <div
          style="border-bottom: 1px solid #dbdbdb;padding-bottom: 16px;font-size: 18px;"
        >{{projectNum_Name}}</div>
      </div>
      <div style="margin-top: -10px;">
        <div style="color: black;font-size: 18px;padding: 15px 0;">项目描述:</div>
        <div
          v-html="project_dataInit.description"
          :style="' max-height:'+ (height - 400) +'px;overflow: auto'"
        ></div>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
.left {
  background-color: #eeeeee;
  padding: 0px 0 0 5px;
}
</style>
<script>
export default {
  name: "",
  data() {
    return {
      side2_menu_height: 160,
      search_word: "",
      project_name: "",
      projectNum_Name: "",
      user_info: {},
      customer_ids: [],
      customer_ids_str: "",
      templates: [],
      manage_user_ids: [],
      join_user_ids: [],
      leader_user_ids: [],
      leader_user_ids_array: [],
      web_token: "",
      projectsList: { list: [], count: "" },
      project_user_list: [],
      project_id: "",
      content: "",
      name: "",
      limit: 1,
      files: [],
      done: false,
      init_list: false,
      is_join: false,
      is_leader: false,
      is_manage: true,
      total: false,
      documents_total: [],
      project_dataInit: { description: "", customer_ids: [], keyword: "" },
      upload_url: "",
      project_list_index: 0,
      edit_projectData: {},
      projectNum: "",
      function_type: 1,
      appUrl: "",
      description: "",
      // show_ellipsis:false,
      description_high: 0,
      project_update_count: 0,
      descriptionVisible: false,
      visit_log: [],
      desc_update: false,
      end_time_update: false,
      user_update: false,
      project_user_update: "",
      documents_update: false,
      is_update: false,
      projectsItemShow: [],
      is_router_alive: false,
      project_usernames: "",
      before_visit_time: ""
    };
  },
  props: ["height", "width"],
  // store,
  methods: {
    backToLogin() {
      this.$router.push("/login");
    },
    // 创建项目成功
    edit_project_success: function() {
      this.project_detail(this.project_id, "edit");
    },
    // 编辑项目成功
    add_project_success: function() {
      this.is_leader = false;
      this.is_update = false;
      this.search_word = "";
      this.getData("add");
    },
    // 编辑项目
    show_project_edit(id) {
      this.$router.push({
        path: "/main/project/project_detail/" + id,
        query: { id: id }
      });
    },
    // 项目
    show_project_detail(id, key) {
      if (this.project_id == id) {
        this.$router.push({
          path: "/main/project/project_files/" + this.project_id,
          query: { id: this.project_id }
        });
        this.reload();
        return false;
      }
      this.show_ellipsis = false;

      if (this.projectsItemShow[key].has_update) {
        this.projectsItemShow[key].has_update = 0;
        this.project_update_count--;
      }
      this.project_list_index = key;

      this.project_detail(id, "default");
    }, // 终止项目
    change_project_status(project_id, status) {
      var tips = status == 2 ? "确定该项目已完成了吗？" : "确定终止该项目吗？";
      this.$confirm(tips, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      })
        .then(() => {
          this.$http
            .post(
              this.web_url + "/project/" + project_id + "/change_status",
              { web_token: this.web_token, status: status },
              { emulateJSON: true }
            )
            .then(function(res) {
              if (res.data.status == "ok") {
                status == 2
                  ? (this.project_dataInit.status = "完成")
                  : (this.project_dataInit.status = "终止");
                this.$router.push({
                  path: "/main/project/project_files/" + this.project_id,
                  query: { id: this.project_id }
                });
              } else if (res.data.error_code == "401") {
                this.backToLogin();
              }
            })
            .catch(function(res1) {
              // console.log(res1);
            });
        })
        .catch(() => {});
    },
    //获取模板 添加项目
    getTemplate: function() {
      this.$http
        .post(
          this.web_url + "/project/vue_template",
          { web_token: this.web_token, system: "web" },
          { emulateJSON: true }
        )
        .then(function(res) {
          // console.log(this.templates);
          if (res.data.status == "ok") {
            this.templates = res.data.data;
            this.is_router_alive = true;
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    // 创建新项目
    add_project() {
      this.$router.push({ path: "/main/project/create_project" });
      this.reload();
    },
    reload: function() {
      this.is_router_alive = false;
      this.$nextTick(function() {
        this.is_router_alive = true;
      });
    },
    download(url) {
      window.open(url);
    },
    //预览
    preview(url, type) {
      if (url.toLowerCase().indexOf(".mp4") < 0 && type == "MP4") {
        return;
        // url = url.replace("/download/","/preview/");
      }
      let routeUrl = this.$router.resolve({
        path: "/preview",
        query: { url: url, type: type }
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({path:'/preview',query:{item:item} })
    },
    //获取项目列表
    getData: function(type, func) {
      this.$http
        .post(
          this.web_url + "/project",
          {
            web_token: this.web_token,
            limits: 1000,
            is_leader: this.is_leader,
            is_update: this.is_update
          },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            // 首次进入页面 如果数据为0 不显示搜索框
            if (res.data.data.list.length > 0) {
              this.init_list = true;
            }
            // if(this.done && res.data.data.project_update_count){
            //     this.init_list = true;
            // }
            this.project_update_count = res.data.data.project_update_count;
            this.projectsList = res.data.data;
            this.done = true;

            if (type == "add" && res.data.data.list.length > 0) {
              this.show_project_detail(this.projectsList.list[0].id, 0);
              this.$router.push({
                path:
                  "/main/project/project_files/" + this.projectsList.list[0].id,
                query: { id: this.projectsList.list[0].id }
              });
            } else {
              this.project_id = "";
            }
            if (typeof func === "function") {
              func();
            }
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    //退出登录
    loginout: function() {
      this.$http
        .post(
          this.web_url + "/logout",
          { web_token: this.web_token, system: "web", model_id: "6" },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            sessionStorage.removeItem("user_info");
            sessionStorage.removeItem("web_token");
            this.$router.push({ path: "/login" });
          } else {
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    //获取项目详情
    project_detail(id, type) {
      // this.selected= 'project_name';

      var _this = this;
      this.$http
        .post(
          this.web_url + "/project/" + id,
          { web_token: this.web_token },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            this.project_dataInit = res.data.data;
            this.project_name = res.data.data.name;
            this.customer_ids = res.data.data.customer_ids;
            this.project_id = id;
            this.projectNum = res.data.data.project_num;
            this.description = this.HTMLEncode(
              this.project_dataInit.description
            );
            this.project_user_list = this.project_dataInit.project_user;
            _this.project_user_list = res.data.data.project_user;
            this.projectsList.list[
              this.project_list_index
            ].objective = this.project_dataInit.objective;
            this.projectsList.list[this.project_list_index].is_objective_more =
              this.project_dataInit.objective_high > 428 ? 1 : 0;
            this.visit_log = this.project_dataInit.visit_log;
            this.before_visit_time = this.project_dataInit.before_visit_time;

            // 获取项目人员
            this.get_project_name();

            // 获取客户
            this.get_clients();

            if (type == "default") {
              console.log(this.project_id);
              this.$router.push({
                path: "/main/project/project_files/" + this.project_id,
                query: { id: this.project_id }
              });
              this.reload();
            }
            // 数据是否有更新
            this.get_update_staus();
          } else if (res.data.status == "error") {
            if (res.data.message == "没有权限！") {
              this.$router.push({ path: "/main/project/welcome" });
              this.getData("");
            }
          } else if (res.data.error_code == "401") {
            this.backToLogin();
          }
        })
        .catch(function(res1) {
          // console.log(res1);
        });
    },
    // 获取项目人员
    get_project_name: function() {
      this.leader_user_ids_array = [];
      this.leader_user_ids = [];
      this.manage_user_ids = [];
      this.join_user_ids = [];
      for (var i = 0; this.project_user_list.length > i; i++) {
        var user_item = this.project_user_list[i];
        if (user_item.key_name == "leader_user_ids") {
          this.leader_user_ids.push(user_item);
          this.leader_user_ids_array.push(user_item.user_id);
        } else if (user_item.key_name == "manage_user_ids") {
          this.manage_user_ids.push(user_item);
        } else if (user_item.key_name == "join_user_ids") {
          this.join_user_ids.push(user_item);
        }
      }

      var userArray = this.leader_user_ids
        .concat(this.join_user_ids)
        .concat(this.manage_user_ids);
      var leader = [];
      var join = [];
      var manage = [];
      this.project_usernames = "";
      for (var i = 0; userArray.length > i; i++) {
        var user_item = userArray[i];
        if (user_item.key_name == "leader_user_ids") {
          leader.push(user_item.username);
        } else if (user_item.key_name == "manage_user_ids") {
          manage.push(user_item.username);
        } else if (user_item.key_name == "join_user_ids") {
          join.push(user_item.username);
        }
      }

      if (manage.length > 0) {
        this.project_usernames = manage.join("、");
        if (manage.length > 0 || join.length > 0) {
          this.project_usernames = this.project_usernames + "; ";
        }
      }

      if (leader.length > 0) {
        this.project_usernames = this.project_usernames + leader.join("、");
        if (join.length > 0) {
          this.project_usernames = this.project_usernames + "; ";
        }
      }

      if (join.length > 0) {
        this.project_usernames = this.project_usernames + join.join("、");
      }
      // this.project_usernames = manage.join('、') + leader.join('、') + join.join('、');
    },
    // 获取客户
    get_clients: function() {
      var client = [];
      for (var i = 0; this.customer_ids.length > i; i++) {
        var _item = this.customer_ids[i];
        client.push(_item.khjc);
      }
      this.customer_ids_str = client.join(",");
    },
    //筛选项目
    selecteProjectList(type) {
      if (type == "is_leader" && !this.is_leader) {
        this.is_leader = !this.is_leader;
      }
      if (type == "total") {
        this.search_word = "";
        this.is_update = false;
        this.is_leader = false;
      }
      this.getData("");
    },
    HTMLEncode(html) {
      var temp = document.createElement("div");
      // temp.innerHTML = html
      temp.textContent != null
        ? (temp.innerHTML = html)
        : (temp.innerText = html);
      var output = temp.innerText;
      temp = null;
      return output;
    },
    //获取更新列表
    get_update_list: function() {
      if (!this.is_update) {
        this.is_update = !this.is_update;
        this.getData("");
      }
    },
    //检查内容是否有更新
    get_update_staus: function() {
      this.desc_update = false;
      this.end_time_update = false;
      this.user_update = false;
      this.documents_update = false;
      this.project_user_update = "";
      for (var i = 0; this.visit_log.length > i; i++) {
        if (this.visit_log[i].type == 1) {
          this.desc_update = true;
        } else if (this.visit_log[i].type == 2) {
          this.end_time_update = true;
        } else if (this.visit_log[i].type == 3) {
          this.user_update = true;
          this.project_user_update = this.visit_log[i].add_user_id;
        } else if (this.visit_log[i].type == 4) {
          this.documents_update = true;
        }
      }
    },
    //查看更多信息
    more_desc: function(num, name) {
      if (this.project_dataInit.description_high > 130) {
        this.projectNum_Name = num + "  " + name;
        this.descriptionVisible = true;
      }
    }
  },
  mounted() {},
  created() {
    this.web_token = sessionStorage.getItem("web_token");
    this.user_info = JSON.parse(sessionStorage.getItem("user_info"));
    this.web_url = sessionStorage.getItem("web_url");

    this.appUrl = this.web_url + "/download_apk.png";
    this.upload_url = this.web_url + "/document/add";

    this.getTemplate();
    // this.getData('');
    if (this.$route.query.id != undefined) {
      var that = this;
      this.getData("", function() {
        // for(var i=0;i<that.projectsList.list.length;i++){
        //   if(that.projectsList.list[i].id == that.$route.query.id){
        //     that.show_project_detail(that.projectsList.list[i].id, i);
        //     break;
        //   }
        // }
        that.project_id = parseInt(that.$route.query.id);
        that.project_detail(that.project_id, "");
      });
    } else {
      this.getData("");
    }
    // this.getDocuments_all();
  },
  watch: {
    projectsList: {
      handler(newName, oldName) {
        var that = this;
        this.projectsItemShow = [];
        for (var i = 0; i < that.projectsList.list.length; i++) {
          if (this.search_word != "") {
            if (
              this.projectsList.list[i].name.indexOf(this.search_word) > -1 ||
              this.projectsList.list[i].keyword.indexOf(this.search_word) >
                -1 ||
              this.projectsList.list[i].project_num.indexOf(this.search_word) >
                -1
            ) {
              this.projectsItemShow.push(this.projectsList.list[i]);
            }
          } else {
            this.projectsItemShow.push(this.projectsList.list[i]);
          }
        }
      },
      immediate: true
    },
    search_word: function() {
      this.projectsItemShow = [];
      for (var i = 0; i < this.projectsList.list.length; i++) {
        console.log(
          this.projectsList.list[i].name.indexOf(this.search_word),
          this.projectsList.list[i].name
        );
        if (
          this.projectsList.list[i].name.indexOf(this.search_word) > -1 ||
          this.projectsList.list[i].project_num.indexOf(this.search_word) > -1
        ) {
          this.projectsItemShow.push(this.projectsList.list[i]);
        } else if (
          this.projectsList.list[i].keyword != null &&
          this.projectsList.list[i].keyword != ""
        ) {
          if (
            this.projectsList.list[i].keyword.indexOf(this.search_word) > -1
          ) {
            this.projectsItemShow.push(this.projectsList.list[i]);
          }
        }
      }
    },
    before_visit_time: {
      handler(newName, oldName) {},
      immediate: true,
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/project/project.vue